export default __webpack_public_path__ + "static/media/DreamStreamLogoSymbol.2a45fb2f.svg";